<template>
  <div class="bg-gray-600">
    <div>
      <div
        class="w-full text-center mx-auto"
        :style="{
          display: !displayUploadbox ? 'inline-block' : 'none',
        }"
      >
        <div v-if="!video.video_source" class="upload videouploadLoader" :style="tabWidth">
          <div class="mb-2 w-full">
            <div class="w-full font-semibold text-left title text-custom-dark mb-1">
              {{ $t('frontend_groovevideo_videos_step1_title') }}
            </div>
            <div class="w-full text-sm h-12 text-left">
              <text-input
                v-model="video.name"
                :validator="$v.video.name"
                value="video.name"
                attribute="Name"
                class="text-deep-dark"
                :placeholder="$t('frontend_groovevideo_videos_step1_name')"
              />
            </div>
          </div>
          <div class="mb-2 w-full">
            <div class="w-full font-semibold text-left title text-custom-dark mb-1">{{ $t('frontend_groovevideo_videos_step1_category') }}</div>
            <div class="w-full text-sm text-left text-deep-dark">
              <div>
                <treeselect
                  v-model="video.category_id"
                  :validator="$v.video.category_id"
                  class="h-10 groovevideo-multilevel-select video-category w-full text-left"
                  :multiple="false"
                  :options="categories"
                  :closeOnSelect="true"
                  :clearable="false"
                  :clearOnSelect="true"
                  :isDefaultExpanded="true"
                  :defaultExpandLevel="1"
                  :showCount="true"
                  :max-height="200"
                  :normalizer="normalizer"
                  :placeholder="
                    $t('frontend_groovevideo_create_select_category')
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="
            w-24
            h-24
            rounded-full
            bg-grey-300
            flex
            items-center
            justify-center
            m-auto
          "
        >
          <img src="../assets/images/videos/upload.png" alt />
        </div> -->
        <h3 class="mt-6 mb-2 dropzone-custom-title">
          {{ $t('frontend_groovevideo_videos_fileupload_drag') }}
        </h3>
        <div class="mx-auto" style="max-width:100%" :style="tabWidth">
          <gd-tabs
            :tabs="uploadTabs"
            :currentTab="currentTab"
            :wrapper-class="'px-0 gs-default-tabs'"
            :tab-active-class="'border-pink border-b-2 text-pink gs-default-tabs-item-active'"
            :line-class="'gs-default-tabs-active-line'"
            :tab-class="tabWidth == 'width: 450px' ? 'w-1/3' : 'w-auto'"
            @onClick="handleTabChange"
            class="uploadTab"
            :key="this.$t('frontend_groovevideo_videos_fileupload_mycomputer')"
          />
        </div>
        <div>
          <div class="fill-w" :key="gdTabKey">
            <div class="py-4 px-2" v-if="currentTab === 'groove'">
              <!-- <groove-storage-uploader
                v-if="!currentUserAllowed"
                :storage-folder="storageFolder"
                :storage-id="storageId"
                :encoder-id="encoderId"
                :is-paid="isPaid"
                :max-size="maxSize"
                :headers="headers"
                :model="video"
                :video-details="videoDetails"
                :remaining="remaining"
                :total-storage="totalStorage"
                :validateForm="validateForm"
                :tabWidth="tabWidth"
                :hasOwnStorage="canUploadVideos"
                @uploadProgress="uploadProgress"
                @updateDisplayUploadbox="updateDisplayUploadbox"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              >
              </groove-storage-uploader> -->
              <aws-uploader
                :use-groove-storage="true"
                :storage-folder="storageFolder"
                :is-paid="isPaid"
                :max-size="5000"
                :headers="headers"
                :model="video"
                :video-details="videoDetails"
                :remaining="remaining"
                :total-storage="totalStorage"
                :validateForm="validateForm"
                :tabWidth="tabWidth"
                :hasOwnStorage="canUploadVideos"
                @uploadProgress="uploadProgress"
                @updateDisplayUploadbox="updateDisplayUploadbox"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              >
              </aws-uploader>
              <groove-storage-alert
                :remaining="remaining"
                :total-storage="totalStorage"
                :has-own-storage="canUploadVideos"
                :tabWidth="tabWidth"
              />
            </div>
            <div class="py-4 px-2" v-else-if="currentTab === 'aws'">
              <aws-uploader
                :storage-folder="storageFolder"
                :storage-id="storageId"
                :encoder-id="encoderId"
                :storage="storage"
                :is-paid="isPaid"
                :max-size="5000"
                :headers="headers"
                :model="video"
                :video-details="videoDetails"
                :validateForm="validateForm"
                :tabWidth="tabWidth"
                @uploadProgress="uploadProgress"
                @updateDisplayUploadbox="updateDisplayUploadbox"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              >
              </aws-uploader>
            </div>
            <div class="py-4 px-2 mx-auto w-full" v-else-if="currentTab === 'youtube'" :style="tabWidth" :key="ytKey">
              <youtube
                :url="model.youtubeUrl"
                :model="video"
                :video-details="videoDetails"
                :accounts="youtubeAccounts"
                :validateForm="validateForm"
                @uploadProgress="uploadProgress"
                @updateDisplayUploadbox="updateDisplayUploadbox"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              >
              </youtube>
            </div>
            <div class="py-4 px-2 w-full mx-auto" v-else-if="currentTab === 'link'" :style="tabWidth">
              <text-input
                v-model="model.mp4Url"
                :validator="$v.model.mp4Url"
                value="model.mp4Url"
                attribute="Mp4 URL"
                :placeholder="$t('frontend_groovevideo_videos_eg_mp4')"
              />
              <div class="flex justify-center mt-6">
                <gd-button v-if="video.video_source" class="mr-4" @click="sendBack">
                {{ $t('frontend_cancel') }}
                </gd-button>
                <gd-button
                  primary                
                  @click="mp4VideoLink"
                >
                  {{ $t('frontend_save') }}
                </gd-button>
              </div>
            </div>
            <!-- <div
              class="
                absolute
                bottom-0
                left-0
                w-full
                flex
                justify-center
                item-center
                bg-pink
                rounded-br rounded-bl
                p-2
              "
            >
              <p class="text-white text-sm">
                {{ $t('frontend_groovevideo_videos_getfree_access') }}
                <gd-button
                  size="large"
                  v-if="!$store.getters.canUseStorage"
                  class="text-center bg-white upgradeBtn ml-2"
                >
                  {{ $t('frontend_groovevideo_videos_upgrade_pro') }}
                </gd-button>
              </p>
            </div> -->
          </div>
        </div>
      </div>
      <div
        class="dz-preview dz-file-preview outputDisplay"
        v-if="displayUploadbox"
      >
        <div class="w-full text-center p-4">
          <div class="preview">
            <div class="c100 m-auto pink" :class="'p' + uploadProgressStatus">
              <span>{{ uploadProgressStatus }} %</span>
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>
            <h6 class="mt-3 w-full inline-block">
              {{ $t('frontend_groovevideo_videos_uploading') }}
            </h6>
            <p class="mt-2">
              {{ $t('frontend_groovevideo_videos_wait_until') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- No storage added modal -->
    <add-storage-modal ref="addStorageModal"/>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert2';
import Auth from '@groovepages/gd-lib/auth';
import axios from 'axios';
import { required, url, minLength, maxLength } from 'vuelidate/lib/validators';
import SourceType from '@/models/SourceType.js';
import themeConfig from '@/theme/themeConfig.js';
import { fetchActivity } from '@/api/index.js';
import Category from '@/models/Category';
import Video from '@/models/Video';
import AddStorageModal from '@/components/AddStorageModal';
import AwsUploader from './ChunkUploaders/ChunkUploadAWS.vue';
import GrooveStorageUploader from './ChunkUploaders/ChunkUploadGrooveStorage.vue';
import GrooveStorageAlert from './ChunkUploaders/GrooveStorageAlert.vue';
import Youtube from './youtubeApi/youtube.vue';

export default {
  components: {
    vueDropzone: vue2Dropzone,
    AddStorageModal,
    Treeselect,
    AwsUploader,
    GrooveStorageUploader,
    GrooveStorageAlert,
    Youtube
  },
  props: {
    storageId: {
      default() {
        return 0;
      },
    },
    storageFolder: {
      default() {
        return 0;
      },
    },
    encoderId: {
      default() {
        return 0;
      },
    },
    storage: {
      default() {
        return [];
      },
    },
    youtubeAccounts: {
      default() {
        return [];
      },
    },
    isPaid: {
      type: Boolean,
      default() {
        return {};
      },
    },
    headers: {},
    maxSize: {},
    videoDetails: {},
  },
  data() {
    return {
      model: '',
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      totalStorage: 100,
      remaining: 100,
      files: [],
      user: null,
      newActivity: {
        status: '',
        msg: '',
      },
      usedData: [],
      isEnabled: 1,
      uploadProgressStatus: 0,
      btnVisible: '',
      categories: [],
      video: {
        name: this.$t('frontend_groovevideo_name_of_video'),
        category_id: 1,
      },
      awss3: {
        signingURL: `${window.config.apiUrl}/get-signing-url`,
        headers: {},
        params: {},
        sendFileToServer: false,
        withCredentials: false,
      },
      dropzoneOptions: {
        acceptedFiles: '.mp4',
        // url: `${window.config.apiUrl}/phpupload`,
        url: 'https://upload.gdapis.com/api/groovevideo/phpupload',
        headers: {
          'email': this.$store.state.user.email, 
          'apiKey': this.$store.state.user.api_key},
        chunking: true,      // enable chunking
        forceChunking: true, // forces chunking when file.size < chunkSize
        parallelChunkUploads: false, // allows chunks to be uploaded in parallel (this is independent of the parallelUploads option)
        chunkSize: 5000000,  // chunk size 1,000,000 bytes (~1MB)
        retryChunks: false,   // retry chunks on failure
        retryChunksLimit: 3, // retry maximum of 3 times (default is 3)
        parallelUploads: 1,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      currentTab: 'youtube',
      model: {
        youtubeUrl: '',
        mp4Url: '',
      },
      displayUploadbox: false,
      nextButtonDisabled: true,
      video_source_type: [],
      gdTabKey: 0,
      ytKey: 0
    };
  },

  computed: {
    canUploadVideos() {
      return  !this.isPaid || (this.storageId > 0 && this.encoderId > 0 && this.storageFolder !== 0);
    },
    uploadTabs () {
      const tabs = [
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_youtube'),
          value: 'youtube',
        },
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_link'),
          value: 'link',
        },
      ];
      if (this.$store.getters.canUseStorage) {
        tabs.splice(1, 0, {
          title: this.$t('frontend_groovevideo_videos_fileupload_groove_storage'),
          value: 'groove',
        });
      }
      if (this.canUploadVideos) {
        tabs.splice(1, 0, {
          title: this.$t('frontend_groovevideo_videos_fileupload_mycomputer'),
          value: 'aws',
        });
      }
      return tabs;
    },
    tabWidth () {
      if (this.canUploadVideos && this.$store.getters.canUseStorage) {
        return "width: 583px";
      }
      if (this.canUploadVideos && !this.$store.getters.canUseStorage) {
        return "width: 435px";
      } 
      return "width: 451px";
      
    },
    currentUserAllowed() {
      // Check if current user is allowed for testing new features
      const allowedUsers = [
        '5f0d5d4a6ca1bd0016c5142f',
        // '9d280130-6f1d-429a-8231-b7d77de8c3c4',
      ];

      return allowedUsers.includes(this.$store.state.user.id);
    },
  },

  validations: {
    video: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      category_id: {
        required,
      },
    },
    model: {
      youtubeUrl: {
        required,
        url,
      },
      mp4Url: {
        required,
        url,
      },
    },
  },

  mounted() {
    this.url = `${window.config.apiUrl}/upload`;
    this.user = this.$store.state.user.id;
    if (this.videoDetails) {
      this.video = this.videoDetails;
      if (typeof this.videoDetails.video_source !== 'undefined' && this.videoDetails.video_source !== null) {
        if (this.videoDetails.video_source_type === 1) {
          this.currentTab = this.videoDetails.is_local !== 1 && this.canUploadVideos ? 'aws' : 'groove';
        } else if (this.videoDetails.video_source_type === 2) {
          this.model.youtubeUrl = !this.videoDetails.is_uploading ? this.videoDetails.video_source : '';
          this.currentTab = 'youtube';
          this.ytKey += 1;
        } else if (this.videoDetails.video_source_type === 3) {
          this.model.mp4Url = this.videoDetails.video_source;
          this.currentTab = 'link';
        }
      }
    }
  },
  async created() {
    this.showLoader();
    // Get video categories
    const category = await Category.$get();
    
    // Set categories
    if(category && category.length !== 0) {
      this.categories = category;
    }
    if (this.$store.getters.canUseStorage !== 0) {
      const remainingData = await axios.get('remaining');
      if (remainingData && remainingData.data && remainingData.data.data) {
        // Convert Bytes to GB
        this.remaining = (remainingData.data.data.res / 1000000000).toFixed(2);
      }
      this.totalStorage = Math.floor((this.$store.getters.maxStorage / 1000000000));
    }
    this.hideLoader();
  },
  methods: {
    sendBack() {
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: this.$route.params.id },
      });
    },
    openUpgradeModal() {
      this.$refs.addStorageModal.open();
    },
    goToStorageSettings () {
      this.$router.push({ name: 'settings', hash: '#ownStorage' });
    },
    updateDisplayUploadbox (value) {
      this.displayUploadbox = value;
      if (value === false) {
        this.uploadProgressStatus = 0;
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.category,
        children: node.child && node.child.length ? node.child : undefined,
        user_id: node.user_id
      };
    },
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    validateForm() {
      this.$v.video.$touch();
      const isValid = !this.$v.video.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    uploadProgress(file, progress, bytesSent, awsUpload = false) {
      // this.uploadProgressStatus = progress;
      if(progress != 100){
        this.uploadProgressStatus = Math.round(progress);
      }
      if (awsUpload) {
        this.uploadProgressStatus = progress;
        this.uploadProgressStatus = Math.round(this.uploadProgressStatus);
      }
    },

    async createVideo() {
      // Create Video
      const video = new Video({
        name: this.video.name,
        category: this.video.category_id,
      });
      this.video = (await video.save()).data;
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    createActivity() {
      this.$emit('activityCreated', this.newActivity);
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
      this.gdTabKey += 1;
    },

    // Get duration of file
    async getFileDurationFromUrl(videoUrl) {
      const videoElement = document.createElement('video');
      videoElement.src = videoUrl;

      return new Promise((resolve) => {
        const timer = setInterval(() => {
          if (videoElement.readyState === 4) {
            // Set duration
            const getTime = videoElement.duration;
            resolve(getTime);
            clearInterval(timer);
          }
        }, 500);
      });
    },

    async mp4VideoLink() {
      this.$v.model.mp4Url.$touch();
      if (!this.$v.model.mp4Url.$invalid) {
        this.showLoader();

        // Creating video if it doesnot already exist
        if (!this.video.id) {
          await this.createVideo();
        }

        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.video.id;
        this.video_source_type.type = 3;
        this.video_source_type.source = this.model.mp4Url;
        this.video_source_type.name = this.video.name;
        this.video_source_type.category = this.video.category_id;
        // Get duration of mp4 URL
        const duration = await this.getFileDurationFromUrl(this.model.mp4Url);
        if (typeof duration === 'number' && duration > 0) {
          this.video_source_type.duration = Math.floor(duration);
        }

        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({
              name: 'AddNewVideo',
              params: { id: this.video.id, mode: 'Mp4' },
            });
          }
        });
      }
    },
    async youtubeVideoLink() {
      this.$v.model.youtubeUrl.$touch();
      if (!this.$v.model.youtubeUrl.$invalid) {
        this.showLoader();

        // Creating video
        if (!this.video.id) {
          await this.createVideo();
        }

        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.video.id;
        this.video_source_type.type = 2;
        this.video_source_type.source = this.model.youtubeUrl;
        this.video_source_type.name = this.video.name;
        this.video_source_type.category = this.video.category_id;

        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({
              name: 'AddNewVideo',
              params: { id: this.video.id, mode: 'youtube' },
            });
          }
        });
      }
    },
  },
};
</script>

<style>
@import '../assets/css/progressbar.css';
#customdropzone .dz-preview .dz-details {
  color: white;
  background-color: #fd6481 !important;
  transition: opacity 0.2s linear;
  text-align: center;
}

.upload.videouploadLoader .dz-message {
  margin: 0!important;
}

.upload.videouploadLoader {
  width: 372px;
  margin: 0 auto;
}

#customdropzone {
  border: 0;
  background: transparent;
  padding: 0;
}

#customdropzone h3 {
  font-size: 20px !important;
  color: #191d3a;
}

#customdropzone {
  text-align: center !important;
}
.upload.videouploadLoader .vue-dropzone .dz-preview {
  display: none !important;
}
.upload.videouploadLoader .vue-dropzone + .dz-preview.outputDisplay {
  display: none !important;
}

.upload.videouploadLoader .vue-dropzone.dz-started + .dz-preview.outputDisplay {
  display: inline-block !important;
}

.dz-progress {
  width: 60px !important;
  height: 60px !important;
  background-color: transparent;
  border-radius: 50% !important;
  display: inline-block;
  border-color: #989ab2;
  border-width: 5px;
  border-style: solid;
}

.upload.videouploadLoader .bgcolor {
  background: #f3f3f5;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 1 !important;
}

.videouploadLoader .dz-preview h6 {
  color: #191d3a;
  font-size: 20px !important;
}
.videouploadLoader .dz-preview p {
  color: #989ab2;
  font-size: 14px;
}

.videouploadLoader .dropzone .dz-preview {
  margin: 0;
  width: 100%;
  height: 100%;
}

.nextbtn,
.nextbtn:hover {
  background: #d5d8e5;
}

.nextbtn.progress100 {
  background: #ea3d5e;
}
.upgradeBtn {
  border-color: white !important;
}

.dz-preview.dz-file-preview.uploadMsg {
  display: inline-block !important;
}
.text-custom-dark {
  color: #374151;
}
.text-deep-dark {
  color: #191d3a !important;
}
</style>
